/* CNC Plasma Table Buying Guide – setup cost calculator. */
(function () {
  'use strict';

  var fmt = function (n) {
    return '$' + Math.round(n).toLocaleString('en-US');
  };
  var num = function (el) {
    var v = parseFloat(el && el.value);
    return isFinite(v) && v > 0 ? v : 0;
  };

  function init(root) {
    if (!root || root.hasAttribute('data-lsbg-ready')) return;
    var dataEl = root.querySelector('[data-lsbg-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data.tables.length) return;
    root.setAttribute('data-lsbg-ready', '');

    var q = function (k) { return root.querySelector('[data-lsbg="' + k + '"]'); };
    var tableInputs = root.querySelectorAll('[data-lsbg="table"]');
    var cutterInputs = root.querySelectorAll('[data-lsbg="cutter"]');
    var hint = root.querySelector('[data-lsbg-cutter-hint]');
    var lines = root.querySelector('[data-lsbg-lines]');
    var out = function (k) { return root.querySelector('[data-lsbg-out="' + k + '"]'); };
    var orderBtn = root.querySelector('[data-lsbg-order]');
    var cutterLink = root.querySelector('[data-lsbg-cutter-link]');

    // Fill editable estimates from the section settings.
    var est = data.estimates || {};
    ['compressor', 'air_treatment', 'electrical', 'software_year', 'hours', 'outsourcing'].forEach(function (k) {
      var el = q(k);
      if (el && el.value === '') el.value = est[k] || 0;
    });
    var consEl = q('consumables_hr');
    var consTouched = false;
    if (consEl) consEl.addEventListener('input', function () { consTouched = true; });

    var checked = function (list) {
      for (var i = 0; i < list.length; i++) if (list[i].checked) return +list[i].value;
      return 0;
    };

    function syncCutters(table) {
      var blocked = [];
      for (var i = 0; i < cutterInputs.length; i++) {
        var c = data.cutters[i];
        var tooBig = c && c.amps > table.amps;
        cutterInputs[i].disabled = !!tooBig;
        if (tooBig) blocked.push(c.name);
      }
      // Move off a cutter the table can't run.
      var cur = cutterInputs[checked(cutterInputs)];
      if (cur && cur.disabled) {
        for (var j = 0; j < cutterInputs.length; j++) {
          if (!cutterInputs[j].disabled) { cutterInputs[j].checked = true; break; }
        }
      }
      if (hint) {
        hint.hidden = !blocked.length;
        hint.textContent = blocked.length
          ? 'The ' + table.name + ' runs cutters up to ' + table.amps + 'A, so ' + blocked.join(' and ') + (blocked.length > 1 ? ' are' : ' is') + ' not available with it.'
          : '';
      }
    }

    function row(label, value, muted) {
      return '<dt>' + label + '</dt><dd' + (muted ? ' class="is-muted"' : '') + '>' + value + '</dd>';
    }

    function calc() {
      var table = data.tables[checked(tableInputs)] || data.tables[0];
      syncCutters(table);
      var cutter = data.cutters[checked(cutterInputs)] || { name: 'Plasma cutter', price: 0, consumables_hr: 0, url: '' };
      var owns = !cutter.price;

      if (consEl && !consTouched) consEl.value = cutter.consumables_hr || 0;

      var parts = [];
      var upfront = table.price;
      parts.push(row(table.name + ' table', fmt(table.price)));

      if (table.shipping_note) {
        parts.push(row('Shipping', table.shipping_note, true));
      } else {
        upfront += table.shipping;
        parts.push(row('Shipping', fmt(table.shipping)));
      }

      upfront += cutter.price;
      parts.push(row(owns ? 'Plasma cutter (you own one)' : cutter.name, owns ? '$0' : fmt(cutter.price), owns));

      [['need_compressor', 'compressor', 'Air compressor'],
       ['need_air', 'air_treatment', 'Air filter / dryer'],
       ['need_electrical', 'electrical', '240V circuit']].forEach(function (r) {
        var on = q(r[0]) ? q(r[0]).checked : true;
        var el = q(r[1]);
        var rowEl = el && el.closest('.lsbg-row');
        if (rowEl) rowEl.classList.toggle('is-off', !on);
        if (on && num(el)) { upfront += num(el); parts.push(row(r[2], fmt(num(el)))); }
      });

      var software = num(q('software_year'));
      var hours = num(q('hours'));
      var perHour = num(consEl);
      var monthly = software / 12 + perHour * hours;

      lines.innerHTML = parts.join('');
      out('upfront').textContent = fmt(upfront);
      var totalLabel = root.querySelector('.lsbg-total__label');
      if (totalLabel) totalLabel.textContent = table.shipping_note ? 'Upfront cost, plus freight' : 'Upfront cost';
      out('monthly').textContent = fmt(monthly);
      out('hourly').textContent = hours ? fmt(monthly / hours) : '—';

      var outsourcing = num(q('outsourcing'));
      var payback = out('payback');
      var saving = outsourcing - monthly;
      if (outsourcing && saving > 0) {
        var months = Math.ceil(upfront / saving);
        payback.innerHTML = 'At <strong>' + fmt(outsourcing) + '/month</strong> in outsourced cutting, this setup pays for itself in about <strong>' +
          months + (months === 1 ? ' month' : ' months') + '</strong>' + (months > 12 ? ' (' + (months / 12).toFixed(1) + ' years)' : '') + '.';
      } else if (outsourcing) {
        payback.textContent = 'At this workload, running costs are higher than what you spend outsourcing. More cutting hours or more outsourced work changes that.';
      } else {
        payback.textContent = 'Enter what you spend on outsourced cutting each month to see a payback estimate.';
      }

      if (orderBtn) {
        orderBtn.href = table.order_url || table.url || '#';
        orderBtn.textContent = 'Build your ' + table.name;
      }
      if (cutterLink) {
        cutterLink.hidden = owns || !cutter.url;
        if (cutter.url) cutterLink.href = cutter.url;
        cutterLink.textContent = cutter.name + ' details →';
      }

      if (window.dataLayer) {
        window.dataLayer.push({ event: 'plasma_setup_cost', table: table.name, cutter: cutter.name, upfront: Math.round(upfront) });
      }
    }

    // Defaults
    if (tableInputs[data.defaultTable]) tableInputs[data.defaultTable].checked = true;
    if (cutterInputs[data.defaultCutter]) cutterInputs[data.defaultCutter].checked = true;

    var t;
    root.addEventListener('input', function () { clearTimeout(t); t = setTimeout(calc, 120); });
    root.addEventListener('change', calc);
    calc();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-lsbg-cost]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
